/**
 * 🤖 AUTO-GENERATED FILE - DO NOT EDIT!
 *
 * This file is automatically generated by vite-plugins/markdown-routes.ts
 * Source: content/blog/drafts/2020-08-05.md
 *
 * ⚠️ Any manual changes will be overwritten on next build.
 *
 * To modify this blog post:
 * 1. Edit the source markdown file: content/blog/drafts/2020-08-05.md
 * 2. Run the build process to regenerate this file
 */

import { createFileRoute } from '@tanstack/react-router';
import { ArticleLayout } from '@/components/ArticleLayout';
import { createArticleMeta } from '@/lib/meta';
import Content from '@/content/2020-08-05.mdx';

const metadata = {
  slug: "2020-08-05",
  title: "reMarkable 2 vs iPad Pro 2020 vs Surface Pro 7",
  author: "Christian Battaglia",
  description: "Comparing the reMarkable 2, iPad Pro 2020, and Surface Pro 7 — three very different approaches to the digital note-taking and tablet experience.\n",
  authorImage: "/assets-cdbattaglia/media/images/chris_profile.svg",
  
  date: "2020-08-05T00:00:00.000Z",
  
  readTime: "1 min read",
  tags: ["hardware","reMarkable","iPad Pro","Surface Pro","note-taking","tablets","comparison","productivity","e-ink"],
};

export const Route = createFileRoute('/blog/posts/2020-08-05')({
  component: ArticlePage,
  head: () => createArticleMeta({
    title: `${metadata.title}${metadata.author ? ` - ${metadata.author}` : ''}`,
    description: metadata.description || '',
    path: '/blog/posts/2020-08-05',
    image: '/og/blog/2020-08-05.png',
    imageAlt: metadata.title,
    datePublished: metadata.date,
    dateModified: undefined,
    authorName: metadata.author,
    tags: metadata.tags,
    readTime: metadata.readTime,
    section: 'Blog',
  }),
});

function ArticlePage() {
  return (
    <ArticleLayout {...metadata}>
      <Content />
    </ArticleLayout>
  );
}
